/**
 * Escapes the characters Postgres treats as metacharacters inside a `LIKE`/`ILIKE` pattern so a
 * user-typed value matches LITERALLY.
 *
 * `%` (any run of characters), `_` (any single character) and `\` (the default escape character) are
 * all meaningful in a pattern. Interpolating a RAW, unescaped search term therefore misbehaves in
 * two ways, and this function exists to prevent both:
 *
 *   * A typed `_` or `%` matches characters the user never asked for — raw `a_b@x.com` also matches
 *     `axb@x.com`.
 *   * A trailing `\` escapes whatever follows it. Wrapped in `%…%` the appended wildcard silently
 *     becomes a literal percent sign (matching nothing, or the wrong thing); passed bare it is a
 *     dangling escape that Postgres rejects outright.
 *
 * Both are properties of a RAW term. Because this function DOUBLES every backslash, its output can
 * never end in a single one, so neither failure survives it — wrapped or bare. Do not "fix" that
 * doubling: it is load-bearing for the share-dialog directory search and for
 * `NotificationRecipientsPicker.lookupOrgUserByEmail`, which applies the same escaping and then
 * passes the value with no wildcards at all.
 *
 * The distinction that keeps tripping readers of this file: those failure modes belong to the
 * INPUT, not to this function's output. Escaped output cannot exhibit either one.
 *
 * Extracted from the inline precedent in `NotificationRecipientsPicker.vue`, which now CALLS this
 * helper rather than repeating it (PR #3838 review low — the claim above that the picker "applies the
 * same escaping" was true of a duplicate, not of a shared invariant).
 */
export function escapeLikeWildcards(value: string): string {
	return value.replace(/([\\%_])/g, "\\$1");
}
